import { components } from "@/__openapi__/backend/schema";
import type { AssertTrue, ValidateEnumIsSubtype } from "@/domains/typing/types";

/**
 * Session Types
 */

export type SmartViewWithSmartCards = components["schemas"]["SmartViewResponseSchema"];
export type SmartView = Omit<SmartViewWithSmartCards, "smart_cards">;

export type GenericSmartCard = SmartViewWithSmartCards["smart_cards"][number];

export enum SmartCardKind {
  NoteList = "NOTE_LIST",
  MentionedByNotesList = "MENTIONED_BY_NOTES_LIST",
  CollectionList = "COLLECTION_LIST",
  EventTimeline = "EVENT_TIMELINE",
  Markdown = "MARKDOWN",
  Unknown = "UNKNOWN",
}

export type SmartCardKindValues = (typeof SmartCardKind)[keyof typeof SmartCardKind];

type _ValidateSmartCardKindValues = AssertTrue<
  ValidateEnumIsSubtype<SmartCardKind, SmartCardKindValues>
>;

export type NoteListSmartCardValue = components["schemas"]["NoteListValueSchema"];
export type MentionedByNotesListSmartCardValue = components["schemas"]["MentionedByValueSchema"];
export type CollectionListSmartCardValue = components["schemas"]["CollectionListValueSchema"];
export type EventTimelineSmartCardValue = components["schemas"]["TimelineValueSchema"];
export type MarkdownSmartCardValue = components["schemas"]["MarkdownValueSchema"];
export type UnknownSmartCardValue = {
  [key: string]: unknown;
};

type BaseSmartCardFields = Omit<GenericSmartCard, "kind" | "value"> & {
  sort_key: string | null;
};

export type NoteListSmartCard = BaseSmartCardFields & {
  kind: SmartCardKind.NoteList;
  value: NoteListSmartCardValue;
};

export type MentionedByNotesListSmartCard = BaseSmartCardFields & {
  kind: SmartCardKind.MentionedByNotesList;
  value: MentionedByNotesListSmartCardValue;
};

export type CollectionListSmartCard = BaseSmartCardFields & {
  kind: SmartCardKind.CollectionList;
  value: CollectionListSmartCardValue;
};

export type EventTimelineSmartCard = BaseSmartCardFields & {
  kind: SmartCardKind.EventTimeline;
  value: EventTimelineSmartCardValue;
};

export type MarkdownSmartCard = BaseSmartCardFields & {
  kind: SmartCardKind.Markdown;
  value: MarkdownSmartCardValue;
};

export type UnknownSmartCard = BaseSmartCardFields & {
  kind: SmartCardKind.Unknown;
  value: UnknownSmartCardValue;
};

export type SmartCard =
  | NoteListSmartCard
  | MentionedByNotesListSmartCard
  | CollectionListSmartCard
  | EventTimelineSmartCard
  | MarkdownSmartCard
  | UnknownSmartCard;

export type NoteSmartCardItem = components["schemas"]["NoteSmartCardItem"];
export type CollectionSmartCardItem = components["schemas"]["CollectionSmartCardItem"];
export type EventSmartEntitySmartCardItem = components["schemas"]["EventSmartEntitySmartCardItem"];

export type SmartCardItem =
  | NoteSmartCardItem
  | CollectionSmartCardItem
  | EventSmartEntitySmartCardItem;
